import * as React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ArticleCollection, Locale } from '../../../../types';
import MobilityHelper from '../../../../helpers/MobilityHelper';
import { useTranslation } from 'react-i18next';
import { collectionLink } from '../../../helpers/NavigationHelper';
import { useSelector } from 'react-redux';
import { AppState } from '../../../store';

const Container = styled(Link)`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  box-sizing: border-box;
  color: rgb(0, 0, 0);
  padding: 16px 20px;
  align-items: center;
  transition: color 250ms, background-color 250ms;
  opacity: 1;
  cursor: pointer;
  gap: 8px;
  text-decoration: none;

  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }

  &::after {
    content: "";
    position: absolute;
    height: 1px;
    bottom: 0px;
    left: 20px;
    right: 20px;
    background-color: rgba(0, 0, 0, 0.06);
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
`

const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const Title = styled.div`
  font-size: 14px;
  line-height: 21px;
  margin-bottom: 4px;
  font-weight: 600;
`

const Description = styled.div`
  font-size: 14px;
  line-height: 21px;
  margin-bottom: 4px;
  word-break: break-word;
  color: rgb(26, 26, 26);
`

const Metadata = styled.div`
  font-size: 14px;
  line-height: 21px;
  display: flex;
  align-items: center;
  color: rgb(26, 26, 26);
  white-space: break-spaces;
  color: rgb(115, 115, 115);
`

interface IProps {
  collection: ArticleCollection
}

const CollectionItem = (props: IProps) => {
  const { collection } = props
  const { t } = useTranslation()
  const currentLocale = useSelector((state: AppState) => state.application.locale)
  const title = MobilityHelper.getTranslation(currentLocale, collection.translations, 'title')
  const description = MobilityHelper.getTranslation(currentLocale, collection.translations, 'description')
  const to = collectionLink(collection)

  return (
    <Container to={to}>
      <Content>
        <Title>{title}</Title>
        <Description>{description}</Description>
        <Metadata>{t('CollectionItem::{{count}} articles', { count: collection.articles_count })}</Metadata>
      </Content>

      <Icon>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M5.42773 4.70898C5.46387 4.85254 5.53809 4.98828 5.65039 5.10059L8.54932 8L5.64893 10.9004C5.31689 11.2324 5.31689 11.7705 5.64893 12.1025C5.98096 12.4336 6.51904 12.4336 6.85107 12.1025L10.3516 8.60059C10.5591 8.39355 10.6367 8.10449 10.585 7.83691C10.5537 7.67578 10.4761 7.52246 10.3516 7.39844L6.85254 3.89941C6.52051 3.56738 5.98242 3.56738 5.65039 3.89941C5.43066 4.11816 5.35645 4.42871 5.42773 4.70898Z" fill="currentColor"></path></svg>
      </Icon>
    </Container>
  )
}

export default CollectionItem